import ArgonTypography from 'components/ArgonTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React from 'react'

import ArgonBox from "components/ArgonBox";


import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components


// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";

import {
  CardHeader,
  CardContent,
  MenuItem,
} from "@mui/material";

import { useState,useEffect } from "react";

import {Grid } from "@mui/material";
import ArgonInput from 'components/ArgonInput';
import ArgonButton from 'components/ArgonButton';
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Checkbox,
  IconButton,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import Dropdown from 'components/CustomDropdown/Dropdown';


function AddTutor() {

  //Dropdown k liye state
  const [selectedOption, setSelectedOption] = useState("");

  return (

   <DashboardLayout>
    <DashboardNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
           <Card
      sx={{
        boxShadow: 6,
        borderRadius: 4,
        overflow: "hidden",
        background: "linear-gradient(180deg, #ffffff 0%, #f6f9fc 100%)",
      }}
    >
      {/* Header */}
      <CardHeader
        title={
          <ArgonTypography
            variant="h5"
            fontWeight="bold"
            color="primary"
            textTransform="uppercase"
          >
             Edit FAQs
          </ArgonTypography>
        }
        
        sx={{
          borderBottom: "2px solid #f0f0f0",
          background: "#fafafa",
          py: 2,
        }}
      />

      {/* Body */}
      <CardContent>
        <form>
          <Grid container spacing={3}>
            {/* Question */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Question
              </ArgonTypography>
              <ArgonInput
                fullWidth
                placeholder="Enter Question"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                  "& .MuiInputBase-root": { borderRadius: "12px" },
                }}
              />
            </Grid>

            {/* Priority */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Priority
              </ArgonTypography>
              <ArgonInput
                type="number"
                fullWidth
                placeholder="Enter Priority"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                }}
              />
            </Grid>

            {/* Answer */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Answer
              </ArgonTypography>
              <ArgonInput
                multiline
                rows={3}
                fullWidth
                placeholder="Enter Answer"
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "12px",
                }}
              />
            </Grid>
               {/* Select For */}
            <Grid item xs={12} md={6}>
              <ArgonTypography
                variant="subtitle2"
                fontWeight="medium"
                color="text"
                mb={1}
              >
                Type
              </ArgonTypography>
              <Dropdown
                options={["Tutor", "Student", "Driver"]}
                value={selectedOption}
                onChange={(e) => setSelectedOption(e.target.value)}
                width="100%"
              />
            </Grid>
          </Grid>

          {/* Footer buttons */}
          <ArgonBox
            display="flex"
            justifyContent="flex-end"
            gap={2}
            mt={4}
          >
            <ArgonButton
              variant="outlined"
              color="secondary"
              href="/admin/fAQs"
              sx={{
                borderRadius: "12px",
                px: 3,
              }}
            >
              Cancel
            </ArgonButton>
            <ArgonButton
              type="submit"
              variant="gradient"
              color="info"
              sx={{
                borderRadius: "12px",
                px: 4,
                fontWeight: "bold",
                boxShadow: "0px 4px 12px rgba(8,2,120,0.4)",
              }}
            >
              Save
            </ArgonButton>
          </ArgonBox>
        </form>
      </CardContent>
    </Card>
        </ArgonBox>
      </ArgonBox>



      <Footer />
    </DashboardLayout>


  )
}

export default AddTutor